import { combineReducers } from "redux";

import currentData from './currentData'

import locationData from './locationData'

import weatherForecast from './weatherForecast'

export default combineReducers({
    currentData,locationData,weatherForecast
})